export type PrivacySettings = {
  publicProfile: boolean;
  verifiedRecruitersOnly: boolean;
  temporaryAccessDays: number;
  allowDirectMessages: boolean;
  allowQuestions: boolean;
  showCalendarAvailability: boolean;
  showEmail: boolean;
  showPhone: boolean;
  showLocation: boolean;
  showSalaryExpectations: boolean;
  showCurrentCompany: boolean;
  showWorkAnniversary: boolean;
  allowResumeDownloads: boolean;
  allowVideoSharingOutside: boolean;
  onlyVerifiedRecruiterInteractions: boolean;
  verifiedRecruiterAutoAccess: boolean;
};

export const DEFAULT_PRIVACY_SETTINGS: PrivacySettings = {
  publicProfile: false,
  verifiedRecruitersOnly: true,
  temporaryAccessDays: 15,
  allowDirectMessages: true,
  allowQuestions: true,
  showCalendarAvailability: false,
  showEmail: true,
  showPhone: false,
  showLocation: true,
  showSalaryExpectations: false,
  showCurrentCompany: false,
  showWorkAnniversary: false,
  allowResumeDownloads: true,
  allowVideoSharingOutside: false,
  onlyVerifiedRecruiterInteractions: true,
  verifiedRecruiterAutoAccess: false,
};

export function mergePrivacySettings(raw: unknown): PrivacySettings {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_PRIVACY_SETTINGS };
  const p = raw as Partial<PrivacySettings>;
  return {
    ...DEFAULT_PRIVACY_SETTINGS,
    ...p,
    temporaryAccessDays:
      typeof p.temporaryAccessDays === 'number'
        ? p.temporaryAccessDays
        : DEFAULT_PRIVACY_SETTINGS.temporaryAccessDays,
  };
}
